import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ic_menu",
  "use": "icon-ic_menu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_menu\">\n<rect opacity=\"0.01\" width=\"24\" height=\"24\" fill=\"#333333\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 2H5C3.34315 2 2 3.34315 2 5V9V19C2 20.6569 3.34315 22 5 22H9H19C20.6569 22 22 20.6569 22 19V9V5C22 3.34315 20.6569 2 19 2ZM10 20H19C19.5523 20 20 19.5523 20 19V10H10V20ZM8 10V20H5C4.44772 20 4 19.5523 4 19V10H8ZM9 8H20V5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V8H9Z\" fill=\"#333333\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol